<div class="main-container">
  <p class="faq-title">Frequently Asked Questions</p>
  <div class="divider"></div>
  <div class="faq-container">
    <mat-accordion [multi]="false">
      <mat-expansion-panel #panel *ngFor="let faq of FAQList; let i=index;let first = first; let last = last" hideToggle>
        <mat-expansion-panel-header [collapsedHeight]="''" [expandedHeight]="''" class="panel-header">
          <mat-panel-title>
            <div style="line-height: 2"><p class="mat-label">{{faq.MessageHeader}}</p></div>
          </mat-panel-title>
          <mat-panel-description *ngIf="panel.expanded" class="expand-icon">
            <mat-icon>expand_more</mat-icon>
          </mat-panel-description>
          <mat-panel-description *ngIf="!panel.expanded" class="expand-icon">
            <mat-icon>chevron_right</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div *ngIf="faq.MessageContent; else noData" class="mat-row-container">
            <div class="mat-parent-td row">
              <div class="mat-td" [innerHTML]="faq.MessageContent | safe_html">
              </div>
            </div>
          </div>
          <ng-template #noData>
            <div class="mat-parent-td col-12">
              <div class="mat-td">
                <p>Loading...</p>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>